import { Priority } from '../../types';
import { useTheme } from '../../contexts/ThemeContext';

const lightPriorityStyles: Record<Priority, string> = {
  low: 'bg-gray-100 text-gray-800',
  medium: 'bg-blue-100 text-blue-800',
  high: 'bg-orange-100 text-orange-800',
  urgent: 'bg-red-100 text-red-800',
};

const darkPriorityStyles: Record<Priority, string> = {
  low: 'bg-gray-900/30 text-gray-400',
  medium: 'bg-blue-900/30 text-blue-400',
  high: 'bg-orange-900/30 text-orange-400',
  urgent: 'bg-red-900/30 text-red-400',
};

interface TicketPriorityBadgeProps {
  priority: Priority;
}

export default function TicketPriorityBadge({ priority }: TicketPriorityBadgeProps) {
  const { theme } = useTheme();

  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
      theme === 'dark' ? darkPriorityStyles[priority] : lightPriorityStyles[priority]
    }`}>
      {priority.charAt(0).toUpperCase() + priority.slice(1)}
    </span>
  );
}